import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule, Directive } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i1 from '@angular/material/menu';

class OneBottomNavigationComponent {
}
OneBottomNavigationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBottomNavigationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneBottomNavigationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneBottomNavigationComponent, selector: "one-bottom-nav", inputs: { appearance: "appearance" }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["one-bottom-nav{height:56px;display:flex;justify-content:space-around;align-items:center;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}one-bottom-nav one-bottom-nav-item{cursor:pointer}one-bottom-nav one-bottom-nav-item .mat-icon{margin-bottom:3px}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBottomNavigationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-bottom-nav',
                    templateUrl: './bottom-navigation.component.html',
                    styleUrls: ['./bottom-navigation.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], propDecorators: { appearance: [{
                type: Input
            }] } });

class BottomNavigationItemComponent {
}
BottomNavigationItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: BottomNavigationItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BottomNavigationItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: BottomNavigationItemComponent, selector: "one-bottom-nav-item", ngImport: i0, template: "<div class=\"mat-caption\">\n  <ng-content></ng-content>\n</div>\n", styles: ["one-bottom-nav-item .mat-caption{display:flex;flex-direction:column;align-items:center}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: BottomNavigationItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-bottom-nav-item',
                    templateUrl: './bottom-navigation-item.component.html',
                    styleUrls: ['./bottom-navigation-item.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneBottomNavigationModule {
}
OneBottomNavigationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBottomNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneBottomNavigationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBottomNavigationModule, declarations: [OneBottomNavigationComponent, BottomNavigationItemComponent], imports: [CommonModule], exports: [OneBottomNavigationComponent, BottomNavigationItemComponent] });
OneBottomNavigationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBottomNavigationModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBottomNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneBottomNavigationComponent, BottomNavigationItemComponent],
                    imports: [CommonModule],
                    exports: [OneBottomNavigationComponent, BottomNavigationItemComponent]
                }]
        }] });

class BreadcrumbElementComponent {
}
BreadcrumbElementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: BreadcrumbElementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbElementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: BreadcrumbElementComponent, selector: "one-breadcrumb-element", ngImport: i0, template: "<ng-content></ng-content>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: BreadcrumbElementComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-breadcrumb-element',
                    templateUrl: './breadcrumb-element.component.html'
                }]
        }] });

class OneBreadcrumbComponent {
}
OneBreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBreadcrumbComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneBreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneBreadcrumbComponent, selector: "one-breadcrumbs", inputs: { breadcrumbs: "breadcrumbs" }, ngImport: i0, template: "<div class=\"breadcrumb\">\n  <div *ngIf=\"breadcrumbs; else customTemplate\">\n    <one-breadcrumb-element *ngFor=\"let breadcrumb of breadcrumbs; last as isLast\">\n      <span *ngIf=\"!isLast\" [routerLink]=\"breadcrumb.url\" class=\"mat-caption\" routerLinkActive=\"router-link-active\">\n        {{ breadcrumb.label }}\n      </span>\n      <span *ngIf=\"isLast\" class=\"mat-small\">\n        {{ breadcrumb.label }}\n      </span>\n      <mat-icon>arrow_right</mat-icon>\n    </one-breadcrumb-element>\n  </div>\n\n  <ng-template #customTemplate>\n    <div>\n      <ng-content></ng-content>\n    </div>\n  </ng-template>\n</div>\n", styles: ["one-breadcrumbs .breadcrumb div{height:40px;display:flex;-webkit-margin-before:0;margin-block-start:0;-webkit-margin-after:0;margin-block-end:0;-webkit-padding-start:0;padding-inline-start:0}one-breadcrumbs .breadcrumb div one-breadcrumb-element{list-style:none;flex-direction:row;display:inline-flex;align-items:center}one-breadcrumbs .breadcrumb div one-breadcrumb-element .mat-icon{margin:0 8px}one-breadcrumbs .breadcrumb div one-breadcrumb-element:last-child mat-icon{visibility:hidden}one-breadcrumbs .breadcrumb div one-breadcrumb-element .mat-caption{cursor:pointer;font-weight:500}\n"], components: [{ type: BreadcrumbElementComponent, selector: "one-breadcrumb-element" }, { type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "routerLinkActive"], exportAs: ["routerLinkActive"] }, { type: i4.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["routerLink", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-breadcrumbs',
                    templateUrl: './breadcrumb.component.html',
                    styleUrls: ['./breadcrumb.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], propDecorators: { breadcrumbs: [{
                type: Input
            }] } });

class OneBreadcrumbModule {
}
OneBreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneBreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBreadcrumbModule, declarations: [OneBreadcrumbComponent, BreadcrumbElementComponent], imports: [CommonModule, RouterModule, MatIconModule], exports: [OneBreadcrumbComponent, BreadcrumbElementComponent] });
OneBreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBreadcrumbModule, imports: [[CommonModule, RouterModule, MatIconModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneBreadcrumbComponent, BreadcrumbElementComponent],
                    exports: [OneBreadcrumbComponent, BreadcrumbElementComponent],
                    imports: [CommonModule, RouterModule, MatIconModule]
                }]
        }] });

class OneFooterComponent {
}
OneFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneFooterComponent, selector: "one-footer", ngImport: i0, template: "<ng-content select=\"one-footer-header\"></ng-content>\n<ng-content select=\"one-footer-content\"></ng-content>\n", styles: ["one-footer{display:flex;flex-direction:column}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-footer',
                    templateUrl: './footer.component.html',
                    styleUrls: ['./footer.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneFooterHeaderComponent {
}
OneFooterHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneFooterHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneFooterHeaderComponent, selector: "one-footer-header", ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["one-footer-header{font-size:14px;font-weight:400;line-height:19px;padding:24px;min-height:64px}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-footer-header',
                    templateUrl: './footer-header.component.html',
                    styleUrls: ['./footer-header.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneFooterContentComponent {
}
OneFooterContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneFooterContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneFooterContentComponent, selector: "one-footer-content", ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["one-footer-content{font-size:14px;font-weight:400;line-height:19px;padding:24px}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-footer-content',
                    templateUrl: './footer-content.component.html',
                    styleUrls: ['./footer-content.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class OneFooterModule {
}
OneFooterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneFooterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterModule, declarations: [OneFooterComponent, OneFooterHeaderComponent, OneFooterContentComponent], imports: [CommonModule], exports: [OneFooterComponent, OneFooterHeaderComponent, OneFooterContentComponent] });
OneFooterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneFooterComponent, OneFooterHeaderComponent, OneFooterContentComponent],
                    imports: [CommonModule],
                    exports: [OneFooterComponent, OneFooterHeaderComponent, OneFooterContentComponent]
                }]
        }] });

class OneMenuDirective {
    constructor(matMenu) {
        this.matMenu = matMenu;
    }
    ngAfterViewInit() {
        this.matMenu.panelClass = 'one-menu';
    }
}
OneMenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneMenuDirective, deps: [{ token: i1.MatMenu }], target: i0.ɵɵFactoryTarget.Directive });
OneMenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneMenuDirective, selector: "mat-menu[oneMenu]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-menu[oneMenu]'
                }]
        }], ctorParameters: function () { return [{ type: i1.MatMenu }]; } });

class OneMenuModule {
}
OneMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneMenuModule, declarations: [OneMenuDirective], imports: [CommonModule], exports: [OneMenuDirective] });
OneMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneMenuModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneMenuDirective],
                    exports: [OneMenuDirective],
                    imports: [CommonModule]
                }]
        }] });

class TopbarDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    ngAfterViewInit() {
        this.renderer.addClass(this.el.nativeElement, 'one-topbar');
    }
}
TopbarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: TopbarDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TopbarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: TopbarDirective, selector: "[oneTopbar]", providers: [], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: TopbarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[oneTopbar]',
                    providers: []
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

class OneTopbarModule {
}
OneTopbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTopbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneTopbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTopbarModule, declarations: [TopbarDirective], imports: [CommonModule], exports: [TopbarDirective] });
OneTopbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTopbarModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTopbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TopbarDirective],
                    exports: [TopbarDirective],
                    imports: [CommonModule]
                }]
        }] });

/*
 * Public API Surface of navigation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BottomNavigationItemComponent, BreadcrumbElementComponent, OneBottomNavigationComponent, OneBottomNavigationModule, OneBreadcrumbComponent, OneBreadcrumbModule, OneFooterComponent, OneFooterContentComponent, OneFooterHeaderComponent, OneFooterModule, OneMenuDirective, OneMenuModule, OneTopbarModule, TopbarDirective };
